module.exports = __webpack_public_path__ + "img/MicrosoftDynamicsAX.034059c2.png";